import { FeatureCollection } from "geojson";

import * as turf from "fond/turf";
import { MuPowerInputLayerIds } from "fond/types";

export const filterAreaSelectData = (layerKey: string, featureCollection: FeatureCollection): FeatureCollection => {
  if (layerKey !== MuPowerInputLayerIds.streets) return featureCollection;

  // The area select data has a 'Highway' field, while the BDDB OSM data has a 'highway' field. We eventually want
  // to stop using area select data here (and instead have a custom workflow for extracting the data from the BDDB).
  // As a future-compatibility measure, we convert the area select data to resemble a subset of the BDDB data.
  return turf.featureCollection(featureCollection.features.map((f) => turf.feature(f.geometry, { highway: f.properties?.Highway ?? null })));
};
